import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods,
  IDP_APPS
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CloudConfigService {
  _errorHandler = handleError.bind(this);

  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  getAppConfig<K>(header: HttpHeadersPayload): Observable<K> {
    const request: Record<string, string> = {
      configuration:
        this.appConfig.getConfig('CLOUD_APP_CONFIG')['APP_CONFIG_SERVICE_NAME']
    };
    return new ApiBuilder<Record<string, string>, K>(this.http, this.appConfig)
      .app(IDP_APPS.CLOUD_APP_CONFIG)
      .endpointKey('APP_CONFIG_SERVICE_API')
      .method(HttpRequestMethods['POST'])
      .httpHeaders(header)
      .payload(request)
      .errorHandler(this._errorHandler.bind(this))
      .create();
  }
}
